import { useState } from 'react';
import MentionsLegalesModal from './MentionsLegalesModal';
import CGUModal from './CGUModal';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [isMentionsOpen, setIsMentionsOpen] = useState(false);
  const [isCGUOpen, setIsCGUOpen] = useState(false);

  return (
    <>
      <footer className="relative bg-gradient-to-br from-aurore-dark via-aurore-medium to-aurore-light dark:from-warm-gray-900 dark:via-warm-gray-800 dark:to-warm-gray-800 text-white font-sans overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE4YzMuMzEgMCA2LTIuNjkgNi02cy0yLjY5LTYtNi02LTYgMi42OS02IDYgMi42OSA2IDYgNiIvPjwvZz48L2c+PC9zdmc+')] opacity-40"></div>

        <div className="relative">
          <div className="h-1 bg-gradient-to-r from-transparent via-white/40 dark:via-warm-gray-600 to-transparent"></div>

          <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-10">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 mb-6 sm:mb-8">
                <div className="text-center md:text-left">
                  <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Informations légales</h3>
                  <div className="flex flex-col items-center md:items-start gap-2 sm:gap-3">
                    <button
                      onClick={() => setIsMentionsOpen(true)}
                      className="text-white/90 hover:text-white transition-colors text-sm sm:text-base font-medium"
                    >
                      Mentions légales
                    </button>
                    <button
                      onClick={() => setIsCGUOpen(true)}
                      className="text-white/90 hover:text-white transition-colors text-sm sm:text-base font-medium"
                    >
                      Conditions Générales
                    </button>
                  </div>
                </div>

                <div className="text-center md:text-right">
                  <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Suivez-nous</h3>
                  <div className="flex items-center justify-center md:justify-end gap-3 sm:gap-4">
                    <a
                      href="https://www.instagram.com/aurore_rh/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group w-11 h-11 sm:w-12 sm:h-12 bg-white/10 hover:bg-white rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-white/20"
                      aria-label="Instagram"
                    >
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white group-hover:text-aurore-dark transition-colors" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </a>
                    <a
                      href="https://wa.me/+33750717728"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group w-11 h-11 sm:w-12 sm:h-12 bg-white/10 hover:bg-white rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-white/20"
                      aria-label="WhatsApp"
                    >
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white group-hover:text-aurore-dark transition-colors" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/aurore-rh/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group w-11 h-11 sm:w-12 sm:h-12 bg-white/10 hover:bg-white rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-white/20"
                      aria-label="LinkedIn"
                    >
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white group-hover:text-aurore-dark transition-colors" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div className="pt-6 sm:pt-8 border-t border-white/20 dark:border-warm-gray-700">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-xs sm:text-sm text-white/90">
                  <span>Copyright © AuroreRH 2024-{currentYear}</span>
                  <span className="hidden sm:inline">•</span>
                  <span className="flex items-center gap-1">
                    Créé avec{' '}
                    <svg
                      className="footer-heart-hover inline-block w-5 h-5 text-white cursor-pointer"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                    </svg>
                    {' '}par{' '}
                    <a
                      href="https://wibeo.fr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-white/80 transition-colors font-medium underline underline-offset-2"
                    >
                      Wibeo
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <MentionsLegalesModal isOpen={isMentionsOpen} onClose={() => setIsMentionsOpen(false)} />
      <CGUModal isOpen={isCGUOpen} onClose={() => setIsCGUOpen(false)} />
    </>
  );
}
